// Info: Import NPM Dependancies
import { useDispatch } from "react-redux";

// Info: Import Local Dependancies
import { endpoints } from "../apiEndpoints"
import { useAxios } from "./axiosInterceptor";
import { setSiteCore, setSiteCoreAPIState, setSiteCoreFailed, API_STATUS } from "../store/sitecoreSlice";




export const useSiteCore = () => {
  const dispatch = useDispatch()
 const {applicationServiceApi} = useAxios();
  const { appUrl, token } = endpoints?.siteCore
  const getSiteCore = async (selectedLanguage: string) => {
    try {
      dispatch(setSiteCoreAPIState(API_STATUS.LOADING))

      const response = await applicationServiceApi.request({
        method: "GET",
        params: { lang: selectedLanguage, token },
        url: appUrl

      })
      // if (selectedLanguage === 'en') {
      //   dispatch(setSiteCore(appTemplateEnglish));
      //   dispatch(setSiteCoreAPIState(API_STATUS.SUCCESS))
      // } else
      if (selectedLanguage === 'ar') {
        dispatch(setSiteCore({}));
        dispatch(setSiteCoreAPIState(API_STATUS.SUCCESS))
      } else {
        dispatch(setSiteCore(response?.data ?? {}));
      }
      
      dispatch(setSiteCoreAPIState(API_STATUS.SUCCESS))

    } catch (err) {
      dispatch(setSiteCoreAPIState(API_STATUS.FAILED))
      dispatch(setSiteCoreFailed())

    }
  }
  return { getSiteCore }
}